type CountryType = {
    name: string;
    phoneNrPrefix: string;
    currency: string;
};

export const countries: Record<string, CountryType> = {
    SE: { name: 'Sweden', phoneNrPrefix: '46', currency: 'SEK' },
    FI: { name: 'Finland', phoneNrPrefix: '358', currency: 'EUR' },
    NO: { name: 'Norway', phoneNrPrefix: '47', currency: 'NOK' },
    DK: { name: 'Denmark', phoneNrPrefix: '45', currency: 'DKK' },
    DE: { name: 'Germany', phoneNrPrefix: '49', currency: 'EUR' },
    NL: { name: 'Netherlands', phoneNrPrefix: '31', currency: 'EUR' },
    EU: { name: 'Europe', phoneNrPrefix: '', currency: 'EUR' },
};

const languageToCountry: Record<string, keyof typeof countries> = {
    sv: 'SE',
    fi: 'FI',
    nb: 'NO',
    nn: 'NO',
    no: 'NO',
    da: 'DK',
    de: 'DE',
    nl: 'NL',
};

export const detectDefaultCurrency = (): string => {
    if (typeof navigator === 'undefined') return 'SEK';

    const locales: string[] = (
        navigator.languages && navigator.languages.length
            ? navigator.languages
            : [navigator.language]
    ).filter(Boolean) as string[];

    for (const locale of locales) {
        const parts = locale.replace(/_/g, '-').split('-');
        const language = parts[0].toLowerCase();
        const region = parts[1]?.toUpperCase();

        if (region && countries[region]) {
            return countries[region].currency;
        }

        if (languageToCountry[language]) {
            return countries[languageToCountry[language]].currency;
        }
    }

    return 'SEK';
};

export const getCountryText = (countryCode: string): string => {
    const entry = countries[countryCode.toUpperCase()];
    return entry?.name ?? '';
};
